module.exports = __webpack_public_path__ + "static/media/landscape.ec137665.jpg";